import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const BlockStyleOne = () => {
    return (
        <Fragment>
            <div className="block-style-one pt-10 mb-45">
                <h2 className="mb-15">Acerca de Nuestra Agencia IT CuyInnovative y Soluciones</h2>
                <p>Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas
                    u "orgánicas". Transparencia y aprovechamiento de recursos.</p>
                <ul className="block-box list-none">
                    <li>
                        <a href="contact.html">
                            <span className="img-bg"><img src="assets/img/icon/icon-1a.svg" alt="icon"/></span>
                            <span>Garantía de Devolución</span>
                        </a>
                    </li>
                    <li>
                        <Link to="contact">
                            <span className="img-bg"><img src="assets/img/icon/icon-2a.svg" alt="icon"/></span>
                            <span>Soporte en Línea 24/7</span>
                        </Link>
                    </li>
                </ul>
                <Link className="theme_btn mt-60" to="/about">Más Detalles</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleOne